// src/pages/PrivacyPolicy.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import NavBar from '../NavBar';
import Footer from '../Footer';

const COMPANY = {
  name: 'Summer House Agent Co., LTD and Real Estate App Co., Ltd.',
  email: 'summerhouseagent@gmail.com',
  phone: '093-581-8543',
  effective: '1 November 2025',
};

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div style={styles.wrapper}>
      <NavBar />
      <main style={styles.container}>
        <h1 style={styles.header}>{t('privacy.title')}</h1>
        <p style={styles.meta}>
          {t('privacy.effective')}: {COMPANY.effective}
        </p>
        <p style={styles.lead}>
          {t('privacy.lead', { company: COMPANY.name })}
        </p>

        {/* Section 1 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section1_title')}</h2>
          <ul style={styles.ul}>
            <li>{t('privacy.section1_point1')}</li>
            <li>{t('privacy.section1_point2')}</li>
            <li>{t('privacy.section1_point3')}</li>
          </ul>
        </section>

        {/* Section 2 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section2_title')}</h2>
          <ul style={styles.ul}>
            <li>{t('privacy.section2_point1')}</li>
            <li>{t('privacy.section2_point2')}</li>
            <li>{t('privacy.section2_point3')}</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section3_title')}</h2>
          <p style={styles.p}>{t('privacy.section3_text')}</p>
        </section>

        {/* Section 4 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section4_title')}</h2>
          <ul style={styles.ul}>
            <li>{t('privacy.section4_point1')}</li>
            <li>{t('privacy.section4_point2')}</li>
            <li>{t('privacy.section4_point3')}</li>
          </ul>
        </section>

        {/* Section 5 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section5_title')}</h2>
          <p style={styles.p}>{t('privacy.section5_text')}</p>
        </section>

        {/* Section 6 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section6_title')}</h2>
          <p style={styles.p}>{t('privacy.section6_text')}</p>
        </section>

        {/* Section 7 */}
        <section style={styles.section}>
          <h2 style={styles.h2}>{t('privacy.section7_title')}</h2>
          <p style={styles.p}>
            {t('privacy.section7_email')}: <a href={`mailto:${COMPANY.email}`} style={styles.link}>{COMPANY.email}</a><br />
            {t('privacy.section7_phone')}: <a href={`tel:${COMPANY.phone}`} style={styles.link}>{COMPANY.phone}</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

const styles = {
  wrapper: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f7f9fb' },
  container: {
    flex: 1,
    width: '100%',
    maxWidth: 900,
    margin: '20px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 8px 20px rgba(0,0,0,0.06)',
    boxSizing: 'border-box',
  },
  header: {
    fontSize: '36px',
    fontWeight: '800',
    marginBottom: '10px',
    color: '#1a2e35',
    letterSpacing: '1.2px',
    textTransform: 'uppercase',
    textAlign: 'center',
    borderBottom: '3px solid #dd9e2a',
    paddingBottom: '8px',
  },
  meta: { textAlign: 'center', color: '#66788a', marginBottom: 18 },
  lead: { fontSize: 16, lineHeight: 1.8, color: '#2c3e50', marginBottom: 16 },
  section: { marginTop: 18 },
  h2: { fontSize: 20, fontWeight: 700, color: '#0f1f2e', marginBottom: 8 },
  p: { fontSize: 16, color: '#2c3e50', lineHeight: 1.8 },
  ul: { paddingLeft: 20, margin: 0, color: '#2c3e50', lineHeight: 1.8 },
  link: { color: '#0d6efd', textDecoration: 'none' },
};
